export const formatTextbox = {
    phoneTH: "(999)-999-9999"
}

export const formatRequired = {
    required: "Required"
}